// extracted by mini-css-extract-plugin
export default {"error":"SettingsToggle_error__LYM-o","card_content":"SettingsToggle_card_content__5uNsJ","list":"SettingsToggle_list__bULst"};